import { RootState } from '../store'

export const getMqttState = (state: RootState) => state.mqtt
